import { useQuery } from '@tanstack/react-query';
import { fetchWaivers } from '../../services/waivers';
import useUser from '../global/useUser';
import useFeatureGuard from '../subscriptions/useFeatureGuard';
import { Feature } from '../../types/subscriptions';

function useGetWaivers({
  enabled: isEnabled = true,
  businessId: businessIdOverride,
}: {
  enabled?: boolean;
  businessId?: string | null;
} = {}) {
  const { user } = useUser();

  const canManageWaivers = useFeatureGuard(Feature.WAIVERS);

  const businessId = businessIdOverride || user?.business?.id;

  const enabled = isEnabled && !!user && !!businessId && canManageWaivers;

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['waivers', { userId: user?.userId, businessId }],
    queryFn: async () => {
      const data = await fetchWaivers({
        businessId: businessId!,
      });
      return data;
    },
    enabled,
  });

  return {
    data: query.data,
    isPlaceholderData: query.isPlaceholderData,
    isLoading: query.isLoading,
    isError: query.isError,
    isFetching: query.isFetching,
    isRefetching: query.isRefetching,
    refetch: query.refetch,
  };
}

export default useGetWaivers;
